import cookies from 'js-cookie'

const save = (key, value) => cookies.set(key, value)

const get = key => cookies.get(key)

const remove = key => cookies.remove(key)

export default { save, get, remove }
